import { BounceLoader } from 'react-spinners';
function Spinner() {
  return (
    <>
      <div className="sweet-loading spinner_dashboard">
        <BounceLoader size={50} thickness={100} speed={100} color="#E57549" />

      </div>
    </>
  )
}

export default Spinner
